import {
  CreateFieldInput,
  CreateFieldTextarea,
  CreateFormActions,
  CreateNextSteps,
  PageTitle
} from '../../components.js';
import { Page } from '../base.js';

export class FormsCreate extends Page {
  static nextSteps = [
    { icon: 'form', label: 'Add questions and field types' },
    { icon: 'link', label: 'Share or embed your form' },
    { icon: 'chart', label: 'Review form submissions' },
    { icon: 'settings', label: 'Connect your workflow' }
  ];

  static timlComponents = {
    CreateFieldInput,
    CreateFieldTextarea,
    CreateFormActions,
    CreateNextSteps,
    PageTitle
  };

  static get formAction() {
    return API.resourceUrl('forms');
  }

  static timl = `
    .auth-create-page.forms-create-page
      <PageTitle title="Create Form">
      .auth-create-content
        p.auth-create-description Create a form to collect structured information from your users.
        .create-page-grid
          form.create-form-card[method="POST" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/forms"]
            .create-form-body
              <CreateFieldInput label="Name" name="name" placeholder="e.g. Contact form" hint="A clear name to identify this form.">
              <CreateFieldTextarea label="Description (optional)" name="description" placeholder="What will this form collect?" hint="Add context for other administrators." required="false" rows="5">
            <CreateFormActions submitLabel="Create" cancelHref="/forms">
          <CreateNextSteps items="{{ Routing.routeObject.nextSteps }}">
  `;
}
